import Api from '@/services/Api'
import GmwApi from '@/services/GmwApi'

export default {
    getall () {
        return Api().get('batches/getallbatches')
    },
    create (data) {
        return Api().post('batches/create', data)
    },
    update (data,id) {
        return Api().post('batches/update/'+id, data)
    },
    delete (id) {
        return Api().delete('batches/delete/'+id)
    },
    checkifexists(product,batch){
        return Api().get('batches/checkifexists/'+product+'/'+batch)
    },

    //
    getallgmw () {
        return GmwApi().get('batches/getallbatches')
    },
    creategmw (data) {
        return GmwApi().post('batches/create', data)
    },
    updategmw (data,id) {
        console.log("GMW update is called")
        return GmwApi().post('batches/update/'+id, data)
    },
    deletegmw (id) {
        return GmwApi().delete('batches/delete/'+id)
    },
    checkifexistsgmw(product,batch){
        return GmwApi().get('batches/checkifexists/'+product+'/'+batch)
    },
}